import { Injectable, inject } from '@angular/core';
import { AuthService as Auth0 } from '@auth0/auth0-angular';
import { catchError, of, Observable, EMPTY } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private authService = inject(Auth0);


  getToken(): Observable<string | null> {
    return this.authService.getAccessTokenSilently()
      .pipe(
        catchError((error) => {
          if (error?.error === 'missing_refresh_token' || error?.error === 'login_required') {
            this.authService.loginWithRedirect();
            return EMPTY;
          }
          console.error('getAccessTokenSilently error', error);
          return of(null);
        }),
      );
  }
}
